export default "__VITE_ASSET__rMP5RbpF__"